import { Box, Card, EmptyState } from '@wix/design-system';
import React from 'react';
import { Header } from '../Header';
import { WixLogo } from '../WixLogo';
export const ErrorPageLayout = ({ image, title, subtitle, Cta, SecondaryCta, hideHeader, backgroundColor = '#ECEFF3', }) => (React.createElement(Box, { direction: "vertical", dataHook: "error-page" },
    !hideHeader && (React.createElement(Header, { logo: React.createElement(WixLogo, { skin: "dark" }), background: "white", height: "48px" })),
    React.createElement("div", { style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '95vh',
            fontFamily: 'Madefor',
            backgroundColor,
        } },
        React.createElement("div", { style: { flex: '1', maxWidth: '754px' } },
            React.createElement(Box, { direction: "vertical" },
                React.createElement(Card, null,
                    React.createElement(Card.Content, null,
                        React.createElement(EmptyState, { theme: "section", image: image, title: title, subtitle: subtitle }, Cta)))),
            React.createElement(Box, { paddingTop: "18px" }, SecondaryCta)))));
//# sourceMappingURL=ErrorPageLayout.js.map